import { gql, useMutation } from '@apollo/client';

import { GET_EMAIL_TEMPLATES } from './get-email-templates.hook';
import { GET_EMAIL_TEMPLATE_BY_ID } from './get-email-template-by-id.hook';

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation updateEmailTemplate($payload: UpdateEmailTemplateInput!) {
    updateEmailTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateEmailTemplate = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateEmailTemplate] = useMutation(UPDATE_EMAIL_TEMPLATE, {
    refetchQueries: [GET_EMAIL_TEMPLATES, GET_EMAIL_TEMPLATE_BY_ID],
    onCompleted: onSuccess,
  });

  return updateEmailTemplate;
};
